const logFactory = (level: string, ...logArgs: any[]) => {
  switch (level) {
    case 'error':
      console.log(...logArgs)
      break
    case 'warning':
      console.log(...logArgs)
      break
    case 'info':
      console.log(...logArgs)
      break
    case 'verbose':
      console.log(...logArgs)
      break
    case 'log':
    default:
      console.log(...logArgs)
      break
  }
}

const log = (title = '', data: any, level = 'log') => {
  const lineChar = '='
  const lineLength = 40
  const lineEnd = '\n'
  const line = new Array(lineLength).fill(lineChar).join('') + lineEnd
  let logString = title

  logString = lineEnd + line + logString + lineEnd + line
  const logArgs = [logString]

  if (data) logArgs.push(data)

  logFactory(level, ...logArgs)
}

export const fatal = (title: string, data: any) => {
  if (!title) return

  log(title, data, 'error')
}

export const error = (title: string, data: any) => {
  if (!title) return

  log(title, data, 'error')
}

export const warn = (title: string, data: any) => {
  if (!title) return

  log(title, data, 'warn')
}

export const info = (title: string, data: any) => {
  if (!title) return

  log(title, data, 'info')
}

export const verbose = (title: string, data: any) => {
  if (!title) return

  log(title, data, 'verbose')
}
